import React, { useState } from 'react';
import { CANCEL_REASONS, cancelJob, holdJob, isOnHold, resumeJob } from '../../services/jobs';
import '../Calls/FollowUpDetail.css';

/**
 * On hold (with a reason) / Resume, and Cancel job (admin) — job Cancelled, its Deal Closed Lost with the
 * reason, red tag; an unpaid invoice is flagged to void in Books (never voided automatically).
 */
const JobActions = ({ job, isAdmin, onToast }) => {
  const [mode, setMode] = useState(null); // 'hold' | 'cancel'
  const [reason, setReason] = useState('');
  const [lostReason, setLostReason] = useState('');
  const [busy, setBusy] = useState(false);
  const onHold = isOnHold(job);

  const run = async (fn) => {
    setBusy(true);
    try {
      onToast(await fn());
      setMode(null);
      setReason('');
      setLostReason('');
    } catch (err) {
      onToast(`⚠ ${err.message}`);
    } finally {
      setBusy(false);
    }
  };

  if (mode === 'hold') {
    return (
      <div className="step-form">
        <label>
          Why is it on hold?
          <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Customer away until Dec 1" maxLength={200} />
        </label>
        <div className="plan-actions">
          <button type="button" className="status-cancel" onClick={() => setMode(null)} disabled={busy}>Cancel</button>
          <button type="button" className="status-save moved" onClick={() => run(() => holdJob(job.id, reason))} disabled={busy || !reason.trim()}>
            {busy ? 'Saving…' : '⏸ Put on hold'}
          </button>
        </div>
      </div>
    );
  }
  if (mode === 'cancel') {
    return (
      <div className="step-form">
        <span className="ca-label">Why is the job cancelled?</span>
        <div className="fud-book-options" role="radiogroup">
          {CANCEL_REASONS.map((r) => (
            <button key={r} type="button" role="radio" aria-checked={lostReason === r} className={`fud-book-option${lostReason === r ? ' selected' : ''}`} onClick={() => setLostReason(r)}>
              <span className="fud-book-radio" aria-hidden="true" />
              <span className="fud-book-name">{r}</span>
            </button>
          ))}
        </div>
        <input className="job-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Note (optional)" maxLength={1000} />
        {job.invoiceNumber && Number(job.balance) > 0 && (
          <p className="ca-muted">{job.invoiceNumber} still shows ${Number(job.balance).toFixed(2)} owing — void it in Zoho Books if it won’t be paid.</p>
        )}
        <div className="plan-actions">
          <button type="button" className="status-cancel" onClick={() => setMode(null)} disabled={busy}>Keep the job</button>
          <button type="button" className="status-save cancelled" onClick={() => run(() => cancelJob(job.id, lostReason, reason))} disabled={busy || !lostReason}>
            {busy ? 'Cancelling…' : '✕ Cancel job'}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="plan-actions">
      {onHold ? (
        <button type="button" className="status-cancel" onClick={() => run(() => resumeJob(job.id))} disabled={busy}>▶ Resume</button>
      ) : (
        <button type="button" className="status-cancel" onClick={() => setMode('hold')} disabled={busy}>⏸ Put on hold</button>
      )}
      {isAdmin && (
        <button type="button" className="status-cancel job-cancel" onClick={() => setMode('cancel')} disabled={busy}>✕ Cancel job</button>
      )}
    </div>
  );
};

export default JobActions;
